import React, { useEffect, useState } from "react";
import {
  AppBar,
  Toolbar,
  Typography,
  IconButton,
  Box,
  InputBase,
  Popover,
  Divider,
  Link,
  Badge,
  Avatar
} from "@mui/material";
import { FaBell } from "react-icons/fa";
import {
  Search,
  AccountCircle,
  Message as MessageIcon,
  Menu as MenuIcon,
} from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchNotifications,
  markAllAsRead,
} from "../../reducers/notificationReducer"; // adjust path if needed

const Header = ({ onDrawerToggle }) => {
  const avatar= useSelector((state)=>state.user.avatar);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const notifications = useSelector((state) => state.notifications?.list || []);
  const unreadNotifications = notifications.filter(notification => notification.Status === 'Unread');

  const userId = useSelector((state) => state.user.userId);

  const [anchorEl, setAnchorEl] = useState(null);

  // Fetch notifications from Redux on component mount
  useEffect(() => {
    dispatch(fetchNotifications());
  }, [dispatch]);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMarkAllRead = () => {
    dispatch(markAllAsRead());
  };

  const handleNotificationClick = (notification) => {
    navigate("/notificationdetails", {
      state: {
        notificationId: notification.Id,
        notifications: [notification],
      },
    });
    handleClose();
  };

  const handleMessageClick = () => {
    navigate("/message");
  };

  const handleProfileClick = () => {
    navigate("/ProfilePage");
  };

  const unreadCount = notifications.filter(
    (n) => n.Status?.toLowerCase() === "unread"
  ).length;

  return (
    <AppBar position="sticky" sx={{ backgroundColor: "#ffffff", color: "#333" }}>
      <Toolbar>
        <IconButton edge="start" onClick={onDrawerToggle} sx={{ display: { sm: "none" } }}>
          <MenuIcon />
        </IconButton>

        <Typography variant="h6" sx={{ flexGrow: 1, color: "green", fontWeight: "bold" }}>
          {/* RealEstate */}
        </Typography>

        {/* Search Bar */}
        {/* <Box
          sx={{
            backgroundColor: "#f1f3f4",
            borderRadius: 2,
            paddingX: 1,
            marginRight: 2,
            display: "flex",
            alignItems: "center",
          }}
        >
          <Search />
          <InputBase placeholder="Search…" sx={{ marginLeft: 1, flex: 1 }} />
        </Box> */}

        {/* Notification Bell */}
        <IconButton onClick={handleClick}>
          <Badge badgeContent={unreadCount} color="error">
            <FaBell />
          </Badge>
        </IconButton>

        {/* Notifications Popover */}
        <Popover
          id="notification-popover"
          open={Boolean(anchorEl)}
          anchorEl={anchorEl}
          onClose={handleClose}
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "right",
          }}
          transformOrigin={{
            vertical: "top",
            horizontal: "right",
          }}
        >
          <Box sx={{ width: 300 }}>
            {/* Header */}
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                backgroundColor: "#0c266c",
                padding: "12px 20px",
                borderRadius: "10px 10px 0 0",
              }}
            >
              <Typography variant="h6" sx={{ color: "#fff", fontSize: "16px" }}>
                {unreadCount} New Notifications
              </Typography>
              <Link
                underline="hover"
                sx={{ color: "#ffffff", fontSize: "0.85rem", cursor: "pointer" }}
                onClick={() => {
                  handleClose();
                  navigate("/admin-notifications", { state: { notifications } });
                }}
              >
                View All
              </Link>
            </Box>

            <Divider />

            {/* Notification List */}
            <Box
              sx={{
                maxHeight: 300,
                overflowY: "auto",
                background: "#5927e3",
                padding: "10px 20px",
              }}
            >
              {unreadNotifications.length === 0 ? (
                <Typography variant="body2" color="#fff">
                  No Unread notifications available.
                </Typography>
              ) : (
                unreadNotifications.map((notification) => (
                  <Box
                    key={notification.Id}
                    onClick={() => handleNotificationClick(notification)}
                    sx={{
                      marginTop: "15px",
                      padding: "8px",
                      borderRadius: "6px",
                      cursor: "pointer",
                      "&:hover": { backgroundColor: "#4a20c0" },
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <Typography variant="body1" fontWeight="bold" sx={{ color: "#fff" }}>
                        {notification.Title}
                      </Typography>
                      <Typography variant="caption" sx={{ color: "#fff", marginLeft: 2 }}>
                        {new Date(notification.created_at).toLocaleString()}
                      </Typography>
                    </Box>
                  </Box>
                ))
              )}
            </Box>

            {/* Footer: Mark All as Read */}
            <Link
              href="#"
              onClick={(e) => {
                e.preventDefault();
                handleMarkAllRead();
              }}
              sx={{
                padding: "12px 20px",
                textAlign: "center",
                color: "#fff",
                fontSize: "16px",
                backgroundColor: "#0c266c",
                display: "block",
                borderRadius: "0 0 10px 10px",
                cursor: "pointer",
              }}
            >
              Mark all as read
            </Link>
          </Box>
        </Popover>

        {/* Message Icon */}
        <IconButton onClick={handleMessageClick} sx={{ marginLeft: 2 }}>
          <MessageIcon sx={{ color: "#4e0dff" }} />
        </IconButton>

        {/* Account Icon */}
          <IconButton onClick={handleProfileClick}>
      {avatar ? (
        <Avatar alt="Profile Avatar" src={avatar} sx={{width:35,height:35}}/>
      ) : (
        <AccountCircle />
      )}
    </IconButton>
      </Toolbar>
    </AppBar>
  );
};

export default Header;
